import React from 'react';
import { Link } from 'react-router-dom';
import classes from './Logo.module.css';

const logo = (props) => ( 
	<div className={classes.LogoWrapper}>
		<Link to="/">
			<img 
				src="/assets/images/ssLogo9.png" 
				alt="Sladko ili Soleno/Sweet or Salted" 
			/>
		</Link>
	</div>
);

export default logo;

